'use client';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { PasswordToggleInput } from '@/components/ui/password-input';
import { useZybookAuth } from '@/providers/zybook-auth-provider';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';

export default function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    const { signIn } = useZybookAuth();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const handleLogin = async (e: any) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            const result = await signIn(email, password);
            if (result.success) {
                const redirectTo = searchParams.get('redirectTo') || '/books';
                navigate(redirectTo);
            } else {
                setError(result.error.message);
            }
        } catch (error: any) {
            setError(error.message || 'An unexpected error occurred during login.');
        }

        setIsLoading(false);
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-gray-100">
            <Card className="w-full max-w-md">
                <CardHeader>
                    <CardTitle className="text-center text-2xl font-bold">Sign In</CardTitle>
                    <CardDescription className="text-center text-sm">Modern Authoring</CardDescription>
                </CardHeader>
                <CardContent>
                    <form onSubmit={handleLogin}>
                        <div className="flex flex-col gap-3">
                            <div className="grid gap-3">
                                <Input
                                    name="email"
                                    type="email"
                                    placeholder="username"
                                    required
                                    autoComplete="username"
                                    disabled={isLoading}
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                />
                                <PasswordToggleInput
                                    disabled={isLoading}
                                    placeholder="password"
                                    name="password"
                                    autoComplete="current-password"
                                    required
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                />
                            </div>
                            <Button
                                type="submit"
                                isLoading={isLoading}
                                className="w-full bg-orange-600 hover:bg-orange-700"
                                disabled={isLoading}
                            >
                                Sign in with zyBooks
                            </Button>
                        </div>
                    </form>

                    <div>{error && <div className="mt-3 text-sm text-red-500">{error}</div>}</div>
                </CardContent>
                <CardFooter className="flex justify-center"></CardFooter>
            </Card>
        </div>
    );
}
